import { getColor } from 'basic-components';
import { CommonEnums } from 'dashboard-services/api/common';
import { DataStorageEnums } from 'dashboard-services/api/dataStorage';
import { ActionService } from 'dashboard-services/services';
import { globalActions } from 'primary-components';

import { LocalStorageUtils, TimeSeriesUtils } from 'utils';

import { MetadataLabel } from 'primary/TsSettings';

// series actions are not dependent on old TimeSeries actions or components
export default (() => {

  const defaultState = {
    csvHeaders: TimeSeriesUtils.DEFAULT_CSV_HEADERS,
    dateFormat: TimeSeriesUtils.DAILY_DATE_FORMAT,
    formatType: DataStorageEnums.DATA_FORMAT.CSV,
    order: CommonEnums.SORT_ORDER.DESCENDING,
    shouldTranspose: "false",
    timeZone: undefined,
    
    range: DataStorageEnums.DATA_RANGE.LAST,
    lastTypeAmount: "500",
    lastType: DataStorageEnums.LAST_TYPE.VALUE,
    
    fromSelected: undefined,
    from: undefined,
    
    toSelected: undefined,
    to: undefined,
    
    sortKeys: "false",
    sortKeysBy: undefined,
    sortKeysOrder: CommonEnums.SORT_ORDER.ASCENDING,
    formulaExpressions: {},
  }
  
  const ON_CHANGE = 'ON_CHANGE_SETTINGS_SERIES'
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')

  const CLEAR = 'CLEAR_LIST_SETTINGS_SERIES'
  const clear = ActionService.makeActionCreator(CLEAR)

  const saveDefaultSettings = () => (_, getState) => {
    const itemsToSave = getState().seriesState.settingsState
    LocalStorageUtils.setTsDefaultSettings(itemsToSave)
  }

  const clearDefaultSettings = () => dispatch => {
    const itemsToSave = defaultState
    LocalStorageUtils.setTsDefaultSettings(itemsToSave)
    dispatch(clear())
    dispatch(globalActions.getMessageStore()).success("Default settings has been restored.")
  }

  const KEYS_TYPE_ORDER = [DataStorageEnums.CSV_HEADER_TYPE.SYMBOL_KEY, DataStorageEnums.CSV_HEADER_TYPE.METADATA_KEY];
  const prepareKeysResponse = response => 
    response
      .flatMap(p => p)
      .filter(g => g !== undefined)
      .reduce((acc, current) => {
        if (!acc.some(obj => obj.value === current.value)) {
          acc.push(current);
        }
        return acc;
      }, [])
      .sort((a,b) => {
        const typeA = KEYS_TYPE_ORDER.indexOf(a.type)
        const typeB = KEYS_TYPE_ORDER.indexOf(b.type)
        if (typeA < typeB) return -1
        if (typeA > typeB) return 1

        if (a.value < b.value) return -1
        if (a.value > b.value) return 1

        return 0
      })
  
  const getSymbolFilter = symbol => {
    const filterSymbolObj = {}
    Object.entries(symbol.symbols || {}).forEach(([key, value]) => {
      filterSymbolObj[key] = value === "*" ? [] : (typeof value === "string" ? [value] : value);
    })

    return filterSymbolObj
  }

  const getMetadataFilter = symbol => {
    const filterMetadataObj = {}
    Object.entries(symbol.metadata || {}).forEach(([key, value]) => {
      filterMetadataObj[key] = value === "*" ? [] : (typeof value === "string" ? [value] : value);
    })

    return filterMetadataObj
  }

  const getSelect = response => (response?.items || []).map(item => ({
    value: item.name, 
    label: item.type === DataStorageEnums.KEY_TYPE.METADATA ? (<MetadataLabel name={item.name}/>) : item.name,
    color: item.type === DataStorageEnums.KEY_TYPE.METADATA ? getColor("grey-dark") : undefined,
    type: `${item.type}_KEY`
  }))

  return {
    onChange,
    ON_CHANGE,
    CLEAR,
    clear,
    saveDefaultSettings,
    clearDefaultSettings,
    defaultState,
    prepareKeysResponse,
    getSymbolFilter,
    getMetadataFilter,
    getSelect
  }
})()
